module.exports = __webpack_public_path__ + "42f29f0d4b65b3d75d85daf69cf2617a.svg";